import type { TourDefinition } from "@/types/tour";

export const entrepreneurOpportunities: TourDefinition = {
  id: "entrepreneur-opportunities",
  context: "entrepreneur",
  version: 1,
  path: "/matched-opportunities",
  steps: [
    {
      element: '[data-tour-id="opportunities-page"]',
      popover: {
        title: "Your opportunities page",
        description:
          "This is where all your matched opportunities live. Let's walk through the key sections.",
      },
    },
    {
      element: '[data-tour-id="opportunities-stats"]',
      popover: {
        title: "Your opportunity stats",
        description:
          "A quick overview of your matches — total opportunities, top scores, and average fit at a glance.",
      },
    },
    {
      element: '[data-tour-id="opportunities-list"]',
      popover: {
        title: "Your matched opportunities",
        description:
          "Each card shows an opportunity matched to your profile, with match scores and key details.",
      },
    },
    {
      element: '[data-tour-id="opportunities-filters"]',
      popover: {
        title: "Filter & refine",
        description:
          "Use these filters to narrow down opportunities by status, match score, or sector.",
      },
    },
    {
      element: '[data-tour-id="opportunity-card-first"]',
      popover: {
        title: "View details",
        description:
          "Click any opportunity card to see the full details, match reasoning, and project information.",
      },
    },
    {
      element: '[data-tour-id="opportunity-apply-btn"]',
      popover: {
        title: "Apply to an opportunity",
        description:
          "Ready to go? Click apply to submit your interest. You can track all your applications afterwards.",
      },
    },
  ],
};
